import logo from './logo.svg';
import './App.css';
import StudentList from './components/StudentList/StudentList';

function App() {
  return (
    <div>
     <h1>ASP.NET WEB API + REACT</h1>
     <StudentList/>
    </div>
  );
}

export default App;
